<template>
  <nx-form :value="value"
           class="nx-scrollytelling-slide-editor-form"
           validation-mode="eager"
           v-on="$listeners"
           ref="form"
           v-slot="{ draft, form }">
    <nx-scrollytelling-slide-configuration-scope :draft="draft"/>
    <nx-form-scope-card title="Texto" icon="text_fields" collapsable>
      <v-layout row wrap>
        <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
          <nx-form-color-picker
            name="textColor"
            :label="$t('message.form.fields.textColor')"
            default="000000"
            :value="draft.textColor"
          />
        </v-flex>
        <v-flex xs12 sm4 :class="{ 'pr-2 pl-2': $vuetify.breakpoint.smAndUp }">
          <nx-form-color-picker
            name="textBackgroundColor"
            :label="$t('message.scrollytelling.fields.textBackgroundColor')"
            :value="draft.textBackgroundColor"
          />
        </v-flex>
        <v-flex xs12 sm4 :class="{ 'pl-2': $vuetify.breakpoint.smAndUp }">
          <nx-form-select
            name="textBackgroundOpacityColor"
            :label="$t('message.scrollytelling.fields.textBackgroundOpacityColor')"
            :items="[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0]"
            :default="100"
            :value="draft.textBackgroundOpacityColor"
          />
        </v-flex>
        <v-flex xs12>
          <nx-form-content-editor
            class="mx-4"
            name="body"
            type="scrollytelling"
            validation="required"
            :label="$t('message.form.fields.body')"
            :sidebar-options="sidebarOptions"
            :value="draft.body"
          />
        </v-flex>
      </v-layout>
    </nx-form-scope-card>
    <nx-form-scope-card title="Columna animada" icon="image" collapsable>
      <v-flex xs12>
        <nx-form-select
          name="multimediaPosition"
          :label="$t('message.form.fields.multimediaPosition')"
          :items="multimediaPositionItems"
          :value="draft.multimediaPosition"
          default="none"
        />
      </v-flex>
      <v-layout row wrap v-if="hasMultimediaColumn">
        <v-flex xs12>
          <nx-form-switch
            name="disableImageTransitions"
            :label="$t('message.form.fields.disableImageTransitions')"
            :value="draft.disableImageTransitions"
          />
        </v-flex>
        <v-flex xs12>
          <nx-scrollytelling-slide-multimedia-list
            name="multimedia"
            :value="draft.multimedia"
          />
        </v-flex>
      </v-layout>
    </nx-form-scope-card>
    <nx-scrollytelling-slide-background-scope :draft="draft" :edit-transition="false" @selection="updateOnSelection"/>
  </nx-form>
</template>

<script>
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxForm from '@/modules/form/Form';
import NxFormSelect from '@/modules/form/components/FormSelect';
import NxFormContentEditor from '@/modules/form/components/FormContentEditor';
import NxScrollytellingSlideConfigurationScope from './components/ScrollytellingSlideConfigurationScope';
import NxScrollytellingSlideBackgroundScope from './components/ScrollytellingSlideBackgroundScope';
import NxScrollytellingSlideMultimediaList from './components/ScrollytellingSlideMultimediaList';
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';
import NxFormSwitch from '@/modules/form/components/FormSwitch.vue';

export default {
  name: 'nx-scrollytelling-slide-editor-form-parallax-text',
  components: {
    NxFormSwitch,
    NxFormColorPicker,
    NxScrollytellingSlideMultimediaList,
    NxFormContentEditor,
    NxFormSelect,
    NxScrollytellingSlideBackgroundScope,
    NxForm,
    NxFormScopeCard,
    NxScrollytellingSlideConfigurationScope,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasMultimediaColumn() {
      return this.value.multimediaPosition !== 'none';
    },
    multimediaPositionItems() {
      return [
        {
          text: this.$t('message.common.none'),
          value: 'none',
        },
        {
          text: this.$t('message.common.left'),
          value: 'left',
        },
        {
          text: this.$t('message.common.right'),
          value: 'right',
        },
      ];
    },
    textHorizontalPositionItems() {
      return [
        {
          text: this.$t('message.common.left'),
          value: 'left',
        },
        {
          text: this.$t('message.common.center'),
          value: 'center',
        },
        {
          text: this.$t('message.common.right'),
          value: 'right',
        },
      ];
    },
    sidebarOptions() {
      return [
        'ql-scrollytelling-spacer',
        'ql-scrollytelling-image',
        'ql-video',
        'ql-tweet',
        'ql-youtube',
        'ql-facebook',
        'ql-instagram',
        'ql-tiktok',
        'ql-code',
      ];
    },
  },
  methods: {
    updateOnSelection() {
      if (this.$refs.form.draft
        && this.$refs.form.draft.backgroundDesktopImage
      ) {
        this.$refs.form.updateField('backgroundImageAlt', this.$refs.form.draft.backgroundDesktopImage.name);
      }
      if (this.$refs.form.draft
        && this.$refs.form.draft.backgroundMobileImage
      ) {
        this.$refs.form.updateField('backgroundImageAlt', this.$refs.form.draft.backgroundMobileImage.name);
      }
    },
  },
};
</script>
